export const DOCS_EXPORT_EXCEL_INVOICES = 'EXCEL_INVOICES'
export const DOCS_EXPORT_EXCEL_INVOICE_LINES = 'EXCEL_INVOICE_LINES'
export const DOCS_EXPORT_CSV_SAP = 'CSV_SAP'
export const DOCS_EXPORT_ORIGINAL = 'ORIGINAL'

export const exportTypes = Object.freeze({
    [DOCS_EXPORT_EXCEL_INVOICES]: {
        key: DOCS_EXPORT_EXCEL_INVOICES,
        label: 'Export Invoices to Excel'
    },
    [DOCS_EXPORT_EXCEL_INVOICE_LINES]: {
        key: DOCS_EXPORT_EXCEL_INVOICE_LINES,
        label: 'Export Invoices with line items to Excel'
    },
    [DOCS_EXPORT_ORIGINAL]: {
        key: DOCS_EXPORT_ORIGINAL,
        label: 'Export Original Documents'
    },
    [DOCS_EXPORT_CSV_SAP]: {
        key: DOCS_EXPORT_CSV_SAP,
        label: 'Export SAP Format'
    }
})

export const exportTypesList = Object.freeze(Object.values(exportTypes))

export const getExportTypeByKey = key => {
    return exportTypesList.find(el => el.key === key) || {}
}
